export default {
    ALICE_CART: '/cart/index/',
    ALICE_CHECKOUT: '/checkout/index/',
    CART: '/shop/cart',
    CART_NATIVE: '/app/shop/cart',
    WISHLIST: '/web/wishlist',
    WISHLIST_NATIVE: '/app/wishlist',
    INTERIOR_DESIGN_SERVICE: '/m/interiorservice',
    INTERIOR_DESIGN_SERVICE_NATIVE: '/app/m/interiorservice',
    HALLO_WELT: '/hallo-welt',
    LOOKS: '/looks',
    SERVICE_PAGE: '/service-page',
};
